export { loyaltyActions } from './loyalty.actions';
export { loyaltyReducer } from './loyalty.reducer';
